import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { default as AnnuityPolicyDetail } from "routes/policy-details/Annuity";
import { default as PayoutAnnuityPolicyDetail } from "routes/policy-details/PayoutAnnuity";
import { default as LifePolicyDetail } from "routes/policy-details/Life";
import AccessDenied from "routes/access-denied";
import { getTypeOfPolicy, isFlagEnabled } from "js/utilities";

export default function PolicyDetails() {
  const { policy_id } = useParams();
  const { policies } = useSelector((state) => state.data);

  const selectedPolicy = policies.find(
    (policy) => policy.contractID === policy_id
  );
  const policyType = getTypeOfPolicy(selectedPolicy?.product?.type);
  const isPayoutPolicy = selectedPolicy?.annuityPayoutIndicatorFlag === "Y";

  if (isFlagEnabled("ENABLE_PAYEES_AS_OWNERS") && isPayoutPolicy) {
    return <PayoutAnnuityPolicyDetail />;
  } else if (policyType === "annuity") {
    if (isFlagEnabled("ENABLE_ANNUITIES")) {
      return <AnnuityPolicyDetail />;
    } else return <AccessDenied />;
  } else return <LifePolicyDetail />;
}
